import CloseIcon from '@mui/icons-material/Close';
import { Avatar, AvatarGroup, useTheme } from '@mui/material';
import Box from "@mui/material/Box";
import Collapse from '@mui/material/Collapse';
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import _ from 'lodash';
import { useState } from "react";
import { lighter } from '../../common/util';
import ActivityCard from '../../enrollment/activity.card';
import StudentName from '../../student/student.name';
import { userApi } from '../../user/user.queries';

export default function CatchupView(props) {
	const catchupFetch = userApi.useCatchup();
	const activities = catchupFetch.data;

	const theme = useTheme();
	const [expand, setExpand] = useState({});//Expand is current state
	const [expanded, setExpanded] = useState({});//Expanded is "if ever been expanded"

	const students = _.chain(activities).map('enrollment.student').uniqBy('id').orderBy('name').filter().value();
	const activityMap = _.groupBy(activities, 'enrollment.studentId');

	if (!activities) {
		return;
	}

	const toggleExpand = (key) => {
		expand[key] = !expand[key];
		setExpand({ ...expand });

		expanded[key] = true;
		setExpanded({ ...expanded });
	}

	const renderStudents = (students) => {
		return students.map(student => {
			const key = student.id;
			const studentSx = { p: 2, background: lighter(student.colour, 0.8, theme) };
			let studentActivities = activityMap[student.id];

			const now = new Date().getTime();
			studentActivities = _.chain(studentActivities)
				.filter(activity => activity?.courseDetail?.isParent == false && activity?.startDate != null && activity?.startDate < now)
				.orderBy(['courseDetail.course.subject.name', 'courseDetail.course.name', 'courseDetail.ordinal'])
				.value();

			const groups = _.groupBy(studentActivities, 'courseDetail.courseId');
			return (
				<Grid size={{ xs: 12, md: 6, xl: 4 }} key={key}>
					<Paper sx={studentSx}>
						<Stack alignItems="center">
							<StudentName student={student} size={24} variant="h5" />
						</Stack>
						<Stack direction="column">
							{Object.keys(groups).map(key => {
								const group = groups[key];
								const colour = group[0]?.courseDetail?.course?.colour || group[0]?.courseDetail?.course?.subject?.colour;
								const last = group.pop();
								const positionSx = {
									position: 'absolute',
									top: -8,
									right: -8,
									cursor: 'pointer',
								};
								const avatarGroupSx = {
									'> *': {
										borderWidth: '0 !important',
										height: '24px !important',
										width: '24px !important',
										fontSize: '12px !important',
										backgroundColor: (colour || theme.palette.info.main) + ' !important',
									}
								};
								const avatarSx = {
									height: 24,
									width: 24,
									backgroundColor: (colour || theme.palette.info.main),
									'> *': {
										height: 16,
										width: 16,
									}
								};

								return (
									<Box key={key}>
										<Box sx={{ position: 'relative' }}>
											{expand[student.id + key] != true && <AvatarGroup total={group.length} sx={[positionSx, avatarGroupSx]} onClick={() => toggleExpand(student.id + key)} />}
											{expand[student.id + key] == true && <Avatar sx={[positionSx, avatarSx]} onClick={() => toggleExpand(student.id + key)}><CloseIcon /></Avatar>}
										</Box>
										<Collapse in={expand[student.id + key]}>
											<Stack direction="column" sx={{ mb: 2 }}>
												{group.map((activity, i) =>
													<ActivityCard activity={activity} hideStudent={true} key={activity.id} />
												)}
											</Stack>
										</Collapse>
										<ActivityCard activity={last} hideStudent={true} />
									</Box>
								);
							})}
						</Stack>
					</Paper>
				</Grid>
			)
		});
	};

	return (
		<Box sx={{ p: 2 }}>
			<Stack justifyContent="space-around" alignItems="center">
				<Typography variant="h5">Catch Up</Typography>
			</Stack>

			<Grid container sx={{ pt: 2 }}>
				{renderStudents(students)}
			</Grid>
		</Box>
	);
}